import { Denm } from '_store/denm/denmsTypes';
import { Map } from 'leaflet';
import React, { FC, ReactElement, useEffect, useRef } from 'react';

import { useClusterRefresh } from '../clustering';
import DenmMarker from './markers/DenmMarker';

const Denms: FC<{ denms: Denm[]; mapRef: Map }> = ({ denms, mapRef }): ReactElement => {
  const refreshClusters = useClusterRefresh();
  const skipFirstRefresh = useRef(true);

  useEffect(() => {
    if (skipFirstRefresh.current) {
      skipFirstRefresh.current = false;
      return;
    }
    refreshClusters();
  }, [denms, refreshClusters]);

  return (
    <>
      {denms.map((denm) => (
        <DenmMarker key={denm.id} denm={denm} mapRef={mapRef} />
      ))}
    </>
  );
};

export default React.memo(Denms);
